import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

const isLoggedIn = (): boolean =>
  !!(
    localStorage.getItem('portalToken') ||
    localStorage.getItem('contacto') ||
    localStorage.getItem('cliente')
  );

export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  if (isLoggedIn()) return true;
  return inject(Router).createUrlTree(['/auth/login']);
};
